import { render, staticRenderFns } from "./SitesViewTable.vue?vue&type=template&id=190b1590&scoped=true&lang=pug"
import script from "./SitesViewTable.vue?vue&type=script&lang=js"
export * from "./SitesViewTable.vue?vue&type=script&lang=js"
import style0 from "./SitesViewTable.vue?vue&type=style&index=0&id=190b1590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b1590",
  null
  
)

export default component.exports